import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { mode, getColor, ink } from "@chakra-ui/theme-tools";

function subtle(props) {
  var t = props.theme,
      c = props.colorScheme;
  var light = getColor(t, c + ".100", c);
  var dark = ink(c + ".200", "lowest")(t);
  var bg = mode(light, dark)(props);
  return {
    Root: {
      bg: bg
    },
    Icon: {
      color: mode(c + ".500", c + ".200")(props)
    }
  };
}

function leftAccent(props) {
  var c = props.colorScheme;
  var subtleStyle = subtle(props);
  return {
    Root: _extends({
      paddingLeft: 3,
      borderLeft: "4px solid",
      borderColor: mode(c + ".500", c + ".200")(props)
    }, subtleStyle.Root),
    Icon: {
      color: mode(c + ".500", c + ".200")(props)
    }
  };
}

function topAccent(props) {
  var c = props.colorScheme;
  var subtleStyle = subtle(props);
  return {
    Root: _extends({
      paddingTop: 2,
      borderTop: "4px solid",
      borderColor: mode(c + ".500", c + ".200")(props)
    }, subtleStyle.Root),
    Icon: {
      color: mode(c + ".500", c + ".200")(props)
    }
  };
}

function solid(props) {
  var c = props.colorScheme;
  return {
    Root: {
      bg: mode(c + ".500", c + ".200")(props),
      color: mode("white", "gray.900")(props)
    }
  };
}

var Alert = {
  defaultProps: {
    variant: "subtle"
  },
  baseStyle: {
    Root: {
      paddingX: 4,
      paddingY: 3
    },
    Icon: {
      marginRight: 3,
      boxSize: 5
    }
  },
  variants: {
    solid: solid,
    subtle: subtle,
    "left-accent": leftAccent,
    "top-accent": topAccent
  }
};
export var AlertVariants = {
  solid: "solid",
  subtle: "subtle",
  "left-accent": "left-accent",
  "top-accent": "top-accent"
};
export default Alert;